var map = {
	"./afrobites.md": [
		4935,
		935
	],
	"./b-scanner.md": [
		1252,
		252
	],
	"./pharmacy-delivery-app.md": [
		7192,
		192
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4008;
module.exports = webpackAsyncContext;